import { useAuth } from "hooks/Auth";
import { useModal } from "hooks/Modal";
import React, { Fragment, useRef } from "react";
import PrimaryButton from "components/Buttons/PrimaryButton";
import { Formik, Form } from "formik";
import TokenInput from "components/FormElements/TokenInput";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import Text from "components/FormElements/Text";
import { oauthGet, oauthPost } from "helpers/Request";
import { transform as roleTransformer } from "schemas/Role";
import { useNotification } from "hooks/Notification";
import { nonce } from "Util";
import { useHistory } from "react-router-dom";

export default function InviteUsers(props) {
    const modal = useModal();
    const auth = useAuth();
    const formRef = useRef();
    const history = useHistory();
    const notification = useNotification();

    const onSubmit = (values) => {
        const userData = Object.assign(
            {},
            {
                emails: values.emails.join(","),
            },
            {
                licenses: [auth.publication.uuid],
                roles: values.roles.map((item) => item.value),
            }
        );

        return oauthPost("/api/v2/invite", userData)
            .then((data) => {
                // setSubmitting(false);
                notification.show("Invites sent!");

                history.push(`/app/user?nonce=${nonce()}`);
            })
            .catch((e) => {
                console.log(e);
                // setSubmitting(false);
                notification.show(
                    "There was an error saving. Please try again."
                );
            });
    };

    const showModal = () => {
        modal.show({
            variant: "wide",
            title: "Invite Users",
            confirmText: "Send Invite",
            children: (
                <Fragment>
                    <Formik
                        initialValues={Object.assign(
                            {},
                            {
                                emails: [],
                                licenses: [
                                    {
                                        label: auth.publication.name,
                                        value: auth.publication.uuid,
                                    },
                                ],
                                roles: [],
                            }
                        )}
                        onSubmit={onSubmit}
                        innerRef={formRef}
                    >
                        <Form className="w-full space-y-6">
                            <TokenInput
                                label="Email Addresses"
                                id="emails"
                                name="emails"
                                type="text"
                                helpertext="Enter one or more email addresses separated by commas. Existing users will be added to your publication."
                                filter={(value) => {
                                    const match = value.match(
                                        // eslint-disable-next-line
                                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                    );
                                    return match && match[0] === value;
                                }}
                            />
                            <Text label="Password">
                                <div>
                                    Password link will be emailed to user.
                                </div>
                            </Text>
                            <Text label="Publication">
                                Users will be added to{" "}
                                <strong>{auth.publication.name}</strong>
                            </Text>
                            <AutocompleteInput
                                label="Groups"
                                id="roles"
                                name="roles"
                                helpertext={
                                    <Fragment>
                                        Showing groups for{" "}
                                        {auth.publication.name}, only.
                                    </Fragment>
                                }
                                onRequestSearch={async (term) => {
                                    let items = await oauthGet("/api/v2/role", {
                                        keyword: term,
                                        license: auth.publication.uuid,
                                    });
                                    return roleTransformer(items).map(
                                        (item) => {
                                            return {
                                                label: item.name,
                                                value: item.id,
                                            };
                                        }
                                    );
                                }}
                            />
                        </Form>
                    </Formik>
                </Fragment>
            ),
            onRequestClose: (closeModal) => {
                modal.set({
                    confirmText: "Sending...",
                });
                formRef.current.submitForm().finally(() => {
                    closeModal();
                });
            },
        });
    };

    return (
        <PrimaryButton type="button" onClick={showModal}>
            Invite Users
        </PrimaryButton>
    );
}
